
import { Outlet, useLocation } from "react-router-dom";

import HeaderBar from "./HeaderBar";

const SharedLayout = () => {
  const location = useLocation();
  const isPublicCloseout = /^\/shared\/jobs\/[^/]+\/?$/.test(
    location.pathname,
  );

  if (isPublicCloseout) {
    return (
      <div className="min-h-screen bg-[#F4F6F8]">
        <HeaderBar closeout />
        <Outlet />
      </div>
    );
  }

  return (
    <>
      <HeaderBar />
      <div style={{ marginTop: "20px" }} />
      <div className="flex">
        <div className="w-full">
          <div className="mt-3">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default SharedLayout;
